import React, {memo, useCallback} from "react";
import {Checkbox, Tooltip} from "@mui/material";
import {ReactComponent as CheckboxIcon} from "../../../../../../../../assets/images/check-box/checkbox.svg";
import {ReactComponent as ActiveCheckboxIcon} from "../../../../../../../../assets/images/check-box/checkbox-active.svg";

export const PreventativeSkipCheckbox = memo(({
                                                   rowIndex,
                                                   fieldKey,
                                                   fieldLabel,
                                                   skipped,
                                                   skipDisabled,
                                                   skipDisabledReason,
                                                   onToggleSkip,
                                                   t,
                                               }) => {
    const handleChange = useCallback((event) => {
        onToggleSkip(rowIndex, fieldKey, event.target.checked);
    }, [fieldKey, onToggleSkip, rowIndex]);

    return (
        <Tooltip
            title={skipDisabled ? skipDisabledReason : t('skipFieldHint')}
            disableHoverListener={!skipDisabled}
        >
            <span>
                <Checkbox
                    size="small"
                    checked={skipped}
                    disabled={skipDisabled}
                    onChange={handleChange}
                    sx={{p: 0.25, flexShrink: 0}}
                    inputProps={{'aria-label': t('skipField', {field: fieldLabel})}}
                    icon={<CheckboxIcon/>}
                    checkedIcon={<ActiveCheckboxIcon/>}
                />
            </span>
        </Tooltip>
    );
});

export default PreventativeSkipCheckbox;
